// @ts-nocheck
/**
 * @generated
 * @file GreenchoiceOntdek (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import Heading from "./webflow_modules/Basic/components/Heading";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";

/**
 * Props for {@link GreenchoiceOntdek}
 */
export type GreenchoiceOntdekProps = {
  title1?: React.ReactNode;
};

/**
 * GreenchoiceOntdek
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function GreenchoiceOntdek({
  title1 = "Ontdek wat er met onze bijdrage gebeurt",
}: GreenchoiceOntdekProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"section-greenchoice"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <BlockContainer
          className={"container-greenchoice"}
          grid={{
            type: "container",
          }}
          tag={"div"}
        >
          <Block className={"vertical-flex-greenchoice"} tag={"div"}>
            <Heading className={"h2-greenchoice"} tag={"h2"}>
              {title1}
            </Heading>
            <Paragraph className={"paragraph-greenchoice"}>
              {
                "Samen met alle Greenchoice-klanten ondersteunen we met Natuur voor Morgen natuurprojecten in Nederland en op veel plekken in de wereld. Op dit platform volg je per project wat er met onze gezamenlijke bijdrage gebeurt. Je ontdekt wat we willen bereiken, hoe onze partners te werk gaan en welke voortgang en resultaten ze boeken."
              }
            </Paragraph>
          </Block>
        </BlockContainer>
      </Section>
    </div>
  );
}
